import type { ComponentPropsWithRef, ReactNode } from 'react';
import type { Menu } from '@ifixit/menu';
import { cn } from '@ifixit/ui/lib/utils';
import { useTrackedOnClick } from '@ifixit/tracking-hooks';

export interface FooterType {
   menu1: Menu | null;
   menu2: Menu | null;
   menu3: Menu | null;
   partners: Menu | null;
   bottomMenu: Menu | null;
}

export function Footer({
   ref,
   children,
   className,
   ...otherProps
}: ComponentPropsWithRef<'footer'>) {
   return (
      <footer ref={ref} className={cn('bg-black py-12', className)} {...otherProps}>
         <div className="mx-auto max-w-[80rem] pl-[max(1rem,var(--safe-left))] pr-[max(1rem,var(--safe-right))] md:pl-[max(1.5rem,var(--safe-left))] md:pr-[max(1.5rem,var(--safe-right))] lg:px-8">
            {children}
         </div>
      </footer>
   );
}

type FooterLinkProps = Omit<ComponentPropsWithRef<'a'>, 'color'> & {
   icon?: ReactNode;
   eventCategory?: string;
   eventAction?: string;
   /** Tailwind text-color class for the link (default `text-white`). */
   colorClassName?: string;
   href?: string;
};

export function FooterLink({
   ref,
   href,
   children,
   icon,
   onClick,
   eventCategory,
   eventAction,
   colorClassName = 'text-gray-300',
   className,
   ...otherProps
}: FooterLinkProps) {
   const trackedOnClick = useTrackedOnClick({
      href,
      onClick,
      eventCategory,
      eventAction,
   });
   return (
      <a
         ref={ref}
         className={cn(
            'inline-flex items-center gap-2 text-sm leading-[1em] transition-colors duration-300 hover:text-white hover:no-underline',
            colorClassName,
            className
         )}
         href={href}
         onClick={trackedOnClick}
         {...otherProps}
      >
         {children}
         {icon}
      </a>
   );
}
